import React from 'react';
// @ts-ignore
import ReactPlayer from 'react-player';
//@ts-ignore
import {ShuffleArray, GetCookieValue} from '../../themes/kent/utilities/functions';
//@ts-ignore
import {GeneralAssetUrl} from '../../themes/kent/utilities/constants';


interface IProps {
  enRetailers?:any;
  euRetailers?:any;
  deRetailers?:any;
  ukRetailers?:any;
  auRetailers?:any;
  ruRetailers?:any;
}

interface IState {
  retailers?:any;
}

/**
 *
 * OnLine Retailer Component
 * @extends {React.Component}
 */
class OnLineRetailers extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      retailers:null
    };
  }

  componentDidMount = () =>{
    //TODO get language
    let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : 'en';
    let retailers = this.props.enRetailers ? this.props.enRetailers : [];
    let displayRetailers = [];
    if(lang === "au"){
      retailers = this.props.auRetailers ? this.props.auRetailers : [];
    }
    if(lang === "uk"){
      retailers = this.props.ukRetailers ? this.props.ukRetailers : [];
    }
    if(lang === "eu"){
      retailers = this.props.euRetailers ? this.props.euRetailers : [];
    }
    if(lang === "de"){
      retailers = this.props.deRetailers ? this.props.deRetailers : [];
    }
    if(lang === "ru"){
      retailers = this.props.ruRetailers ? this.props.ruRetailers : [];
    }
    console.log(retailers)
    ShuffleArray(retailers);
    retailers = retailers.slice(0,12);
    for (let i = 0; i < retailers.length; i++) {
      let retailer = retailers[i];
      if (retailer) {
        let image: any = "";
        if (retailer.image) {
          if (retailer.image?.src) {
            image = retailer.image?.src;
          }
        }
        let link: any = "";
        if (retailer.link) {
          if (retailer.link?.linkUrl) {
            if (retailer.link?.linkUrl?.destinationUrl) {
              link = retailer.link?.linkUrl?.destinationUrl;
            }
          }
        }
        displayRetailers.push({
          name: retailer.name,
          image: image,
          link: link
        });
      }
    }
    this.setState({
      retailers:displayRetailers
    })
  }

  trackOnlineLink = (data:any) => {
    var link:any = data.link;
    window.open(link);
  }

  public render(): JSX.Element {
    console.log(this.state.retailers)
    if(!this.state.retailers) return <span />;
    return (
      <div className="row full-width">
        {this.state.retailers.map((data:any,index:number) =>{
          return(
            <div className="small-2 medium-1" style={{"padding":"2px"}}>
              <div className="background-image-fill" onClick={() => this.trackOnlineLink(data)} style={{"cursor":"pointer", backgroundImage:"url("+data.image+")"}}>
                <img className="full-width" src={GeneralAssetUrl+'square.png'} />
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}

export default OnLineRetailers;
